import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Tabs, Tooltip} from 'antd';
import Base from '../Base';
import ServiceHealthWarning from '../ServiceHealthWarning';
import DownloadXmlTab from './DownloadXmlTab';
import EFOSValidationTab from './EFOSValidationTab';
import {pageGA} from '../../Helpers/GoogleAnalytics';
import RoleHelper from "../../Helpers/RoleHelper";
import user from "../../Actions/user";
import {InfoCircleOutlined} from "@ant-design/icons";

const {getRoleData} = user.actions;

const {TabPane} = Tabs;

class Portal extends Component {
    constructor(props) {
        super(props);
        this.props.getRoleData();
    }

    render() {
        pageGA();
        return (
            <Base>
                <ServiceHealthWarning />
                <h1 className="title-text blue-text">Selecciona tu tipo de solicitud:</h1>
                <Tabs defaultActiveKey="1" size="medium" destroyInactiveTabPane>
                    <TabPane tab="Descarga XML" key="1">
                        <DownloadXmlTab/>
                    </TabPane>
                    <TabPane disabled={!this.props.showEfosTab} tab={
                        <>
                            Validación EFOS y Cancelados
                            {this.isFreePlan && <Tooltip
                                zIndex={100}
                                placement="right"
                                visible={true}
                                title="Disponible a partir del plan Base"
                                color="red"/>
                            }
                            {!this.props.showEfosTab ?
                                <Tooltip
                                    placement="bottom"
                                    title="No puedes realizar la solicitud de descarga de cancelados o EFOS debido a que tu rol asignado no lo permite">
                                    <InfoCircleOutlined style={{color: 'red', marginLeft: '10px'}} />
                                </Tooltip> :
                                null
                            }
                        </>
                    }
                             key="2">
                        <EFOSValidationTab/>
                    </TabPane>
                </Tabs>
            </Base>
        );
    }
};

const mapStateToProps = state => {
    const roleHelper = new RoleHelper(state.user.role);
    const showEfosTab = roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOAD, RoleHelper.DOCUMENT_TYPE_EMITIDOS) ||
        roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOAD, RoleHelper.DOCUMENT_TYPE_RECIBIDOS)
    return {
        isFreePlan: state.license.isFreePlan,
        showEfosTab
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getRoleData() {
            dispatch(getRoleData());
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Portal);